export default __webpack_public_path__ + "static/media/bgm-004.5158ec39.mp3";